var map = {
	"./arts.png": "bf05",
	"./banner.png": "d22d",
	"./bdo-logo.png": "4c91",
	"./bottle.png": "aafd",
	"./buyboy-rating.png": "5c96",
	"./coffee.png": "0adf",
	"./dessert.png": "e517",
	"./gadget.png": "af0d",
	"./hammer.png": "5054",
	"./hot.png": "60b1",
	"./like.png": "ef74",
	"./logo.png": "4ffd",
	"./lunch.png": "8827",
	"./notfound.png": "3e1d",
	"./order-complete-icon.png": "8df1",
	"./order-delivery-icon.png": "101b",
	"./order-placed-icon.png": "c60a",
	"./order-preparing-icon.png": "5b36",
	"./paypal-logo.png": "e9ad",
	"./shopping-cart-icon.png": "a429",
	"./snacks.png": "2654",
	"./strawberry.png": "6646",
	"./toy.png": "5736",
	"./trending.png": "1d73"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";